import React, { useMemo } from 'react'
import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import { useGetAllStock } from '../../api/stock'

export const StockFilter = (props) => {
  const { department, setDepartment, classification, setClassification, setItemId } = props

  const allStockRes = useGetAllStock()
  const allStockData = allStockRes?.data ?? []

  const { departmentArray, classificationArray } = useMemo(() => {
    const departmentArray = allStockData
      .filter(
        (stock, index, array) =>
          array.findIndex((each) => each.department === stock.department) === index
      )
      .map((stock) => {
        return stock.department
      })
      .sort()

    const classificationArray = allStockData
      .filter(
        (stock, index, array) =>
          array.findIndex((each) => each.classification === stock.classification) === index
      )
      .map((stock) => {
        return stock.classification
      })
      .sort()

    return { departmentArray, classificationArray }
  }, [allStockData])

  const handleSelectDepartment = (event) => {
    setDepartment(event.target.value)
    setItemId('')
  }

  const handleSelectClassification = (event) => {
    setClassification(event.target.value)
    setItemId('')
  }

  return (
    <Box mb={3}>
      <Box
        display='flex'
        justifyContent='space-between'
        maxWidth={650}
        mb={3}
        minHeight={{ xs: 100, md: 0 }}
        flexDirection={{ xs: 'column', md: 'row' }}
      >
        <Box minWidth={{ xs: 250, md: 300 }}>
          <FormControl fullWidth>
            <InputLabel id='department-label'>Department</InputLabel>
            <Select
              labelId='department-label'
              id='department-select'
              value={department}
              label='Department'
              onChange={handleSelectDepartment}
              size='small'
            >
              {departmentArray?.map((department, idx) => (
                <MenuItem value={department} key={idx}>
                  {department}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box minWidth={{ xs: 250, md: 300 }}>
          <FormControl fullWidth>
            <InputLabel id='classification-label'>Classification</InputLabel>
            <Select
              labelId='classification-label'
              id='classification-select'
              value={classification}
              label='Classification'
              onChange={handleSelectClassification}
              size='small'
            >
              {classificationArray?.map((classification, idx) => (
                <MenuItem value={classification} key={idx}>
                  {classification}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
    </Box>
  )
}
